import React, { useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { View } from 'react-native'
import styled from 'styled-components/native'
import { useSelector } from 'react-redux'
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen'
import Svg, { G, Polygon, Path } from 'react-native-svg'
import moment from 'moment-timezone'
import '@expo/vector-icons'
import visitor from '../../../services/visitor'
import { EventEmitter } from '../../../services/events'
import { WebinarContext } from '../Context'

const Info = props => {
  const { statusBarPadding, fullScreenVideo } = useContext(WebinarContext)
  const { attendees, webinar } = useSelector(state => state.viewer.data)

  const [timer, setTimer] = useState(0)

  const t = moment.duration(timer, 'seconds')
  const value = `${t.hours() > 0 ? `${t.hours()}:` : ''}${t.minutes() < 10 ? '0' : ''}${t.minutes()}${t.seconds() < 10 ? ':0' : ':'}${t.seconds()}`

  useEffect(() => {
    EventEmitter.subscribe('screensaver.time', time => {
      setTimer(time)
    })

    return () => {
      EventEmitter.unsubscribe('screensaver.time')
    }
  }, [])

  if (visitor.viewer_session.is_replay) return null

  const nowWidth = t.hours() > 0 ? 52 : 42

  const filteredAttendees = attendees.filter(a => a.startTime < timer && a.endTime > timer)

  return (
    <Wrapper style={props.style} fullScreenVideo={ fullScreenVideo }>
      {
        webinar.live_icon !== 'disabled'
        ? <LiveNow>
            <LiveNowLabel>Live: </LiveNowLabel>
            <LiveNowValue width={nowWidth}>{ value }</LiveNowValue>
          </LiveNow>
        : null
      }
      {
        webinar.attendees_tab !== 'disabled' && webinar.attendees_icon !== 'disabled'
        ? <Watching>
            <WatchingIcon></WatchingIcon>
            <WatchingText>{ filteredAttendees.length }</WatchingText>
          </Watching>
        : null
      }
    </Wrapper>
  )
}
Info.propTypes = {
}

const Wrapper = styled.View`
  flex-direction: row;
  z-index: 10;
`

const LiveNow = styled.View`
  flex-direction: row;
  align-items: center;
  padding-left: 14px;
  padding-right: 7px;
  height: 30px;
  margin-right: 15px;
  border-radius: 8px;
  background-color: #f53b2f;
`

const LiveNowLabel = styled.Text`
  font-family: Gilroy-Bold;
  font-size: 14px;
  line-height: 16px;
  height: 14px;
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
`

const LiveNowValue = styled.Text`
  font-family: Gilroy-Bold;
  font-size: 14px;
  line-height: 16px;
  height: 14px;
  width: ${props => props.width}px;
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
`

const Watching = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 65px;
  height: 30px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.4);
`

const WatchingText = styled.Text`
  font-family: Gilroy-Bold;
  font-size: 14px;
  height: 14px;
  letter-spacing: 1.3px;
  color: #ffffff;
  margin-left: 6px;
`

const WatchingIcon = () => (
  <Svg width="19px" height="13px" viewBox="0 0 19 13">
    <G stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <G transform="translate(-30.000000, -121.000000)" fill="#FFFFFF" fillRule="nonzero">
        <G transform="translate(30.000000, 121.000000)">
          <Path d="M9.49985156,4.4686392 C8.57901953,4.4686392 7.82985547,5.21421875 7.82985547,6.13064489 C7.82985547,7.04707102 8.57901953,7.79265057 9.49985156,7.79265057 C10.4206836,7.79265057 11.1698477,7.04707102 11.1698477,6.13064489 C11.1698477,5.21421875 10.4206836,4.4686392 9.49985156,4.4686392 Z M9.49985156,6.68465909 C9.19291992,6.68465909 8.94317383,6.43614489 8.94317383,6.13064489 C8.94317383,5.82514489 9.19288281,5.57663068 9.49985156,5.57663068 C9.8067832,5.57663068 10.0565293,5.82514489 10.0565293,6.13064489 C10.0565293,6.43614489 9.8067832,6.68465909 9.49985156,6.68465909 Z"></Path>
          <Path d="M18.8946836,5.80608807 C18.8520449,5.74736648 17.8309805,4.35175 16.1789453,2.9403267 C14.301916,1.33659943 11.9826914,0.0366363636 9.49981445,0.0366363636 C7.01630664,0.0366363636 4.69685937,1.33733807 2.82068359,2.9403267 C1.16875977,4.35175 0.147658203,5.74732955 0.105019531,5.80608807 C-0.0359589844,6.00023864 -0.0339921875,6.26444886 0.105019531,6.45527557 C0.147658203,6.51399716 1.16875977,7.90961364 2.82075781,9.32103693 C4.69767578,10.9246534 7.01701172,12.2247273 9.49988867,12.2247273 C11.8966348,12.2247273 14.0807812,11.033233 15.9201445,9.53354261 C17.1426387,8.53678977 18.2063789,7.4027983 18.8947207,6.45527557 C19.0349941,6.26215909 19.0350684,5.99924148 18.8946836,5.80608807 Z M3.45076367,3.86561648 C5.0045332,2.51638636 7.15958594,1.14462784 9.49985156,1.14462784 C11.8628281,1.14462784 14.0316855,2.56964205 15.435125,3.76508807 C15.5984062,3.9041733 15.7553047,4.04351705 15.9056719,4.18153125 C13.9226582,3.3516733 11.6978398,2.80659659 9.49985156,2.80659659 C7.30765234,2.80659659 5.08587695,3.34871875 3.09941211,4.17924148 C3.21274414,4.07527841 3.32993555,3.97050284 3.45076367,3.86561648 Z M12.283166,6.13064489 C12.283166,7.65803409 11.0345469,8.90064205 9.49985156,8.90064205 C7.96511914,8.90064205 6.71653711,7.65803409 6.71653711,6.13064489 C6.71653711,5.32427557 7.0616543,4.57215909 7.66820703,4.04499432 C8.25739258,3.96307955 8.87095898,3.914625 9.49985156,3.914625 C10.1287441,3.914625 10.7423477,3.96311648 11.3315332,4.04499432 C11.9380488,4.57215909 12.283166,5.32427557 12.283166,6.13064489 Z M15.2891367,8.61682102 C13.759377,9.8906733 11.7123867,11.1166619 9.49985156,11.1166619 C7.13691211,11.1166619 4.96798047,9.69164773 3.56457812,8.4962017 C2.56518555,7.6449233 1.79961914,6.78422727 1.37653516,6.27305398 C2.73952539,5.4712642 4.36773633,4.78414773 6.02745312,4.36652273 C5.75139648,4.90428693 5.60314453,5.50572159 5.60314453,6.13064489 C5.60314453,8.26899716 7.35118164,10.0086705 9.49981445,10.0086705 C11.6484473,10.0086705 13.3964844,8.26899716 13.3964844,6.13064489 C13.3964844,5.50575852 13.2482695,4.90428693 12.9722129,4.36652273 C14.6294805,4.78355682 16.2576172,5.46982386 17.6227598,6.27283239 C17.1799707,6.80705114 16.3616719,7.72369886 15.2891367,8.61682102 Z"></Path>
        </G>
      </G>
    </G>
  </Svg>
)

export default Info
